import {
  ShieldCheck,
  RotateCcw,
  Truck,
  Banknote,
  Coins,
  Lock,
  Package,
  Star,
  Users,
  MessageCircle,
  User,
  Clock,
  type LucideIcon,
} from 'lucide-react';
import type { StorefrontIconKey } from '@mlm/shared';

/**
 * Maps the closed `StorefrontIconKey` allow-list (stored in tenant config) to
 * lucide components. Lives in @mlm/ui so BOTH the buyer storefront (member app)
 * and the admin storefront editor render the same glyphs from one registry —
 * config carries a stable string, never a component reference. Unknown keys
 * fall back to a neutral icon.
 */
export const STOREFRONT_ICONS: Record<StorefrontIconKey, LucideIcon> = {
  shield: ShieldCheck,
  rotate: RotateCcw,
  truck: Truck,
  banknote: Banknote,
  coins: Coins,
  lock: Lock,
  box: Package,
  star: Star,
  users: Users,
  chat: MessageCircle,
  user: User,
  clock: Clock,
};

export function storefrontIcon(key: StorefrontIconKey): LucideIcon {
  return STOREFRONT_ICONS[key] ?? ShieldCheck;
}
